var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 80,
    viewBox: "0 0 18 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M18,71.25A8.873,8.873,0,0,1,9,80a8.88,8.88,0,0,1-9-8.75,8.652,8.652,0,0,1,4.2-7.39V4.66A4.728,4.728,0,0,1,9,0a4.73,4.73,0,0,1,4.81,4.66V63.85A8.694,8.694,0,0,1,18,71.25Z",
    fill: "#58595b"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_348",
    "data-name": "Ellipse 348",
    cx: 7.58,
    cy: 7.37,
    rx: 7.58,
    ry: 7.37,
    transform: "translate(1.42 63.88)",
    fill: "#929497"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureOff);
export default __webpack_public_path__ + "static/media/temperature_off.449ffcabf73ba84a3f450aa1313e13a1.svg";
export { ForwardRef as ReactComponent };